export const appVersion = '2.26.0';
